<script lang="ts">
  import { getContext } from "svelte";
  import type { StepperControl, Step } from "./Stepper.svelte";

  let progress = 0;
  let steps: (Step & { index: number })[];
  let currentIndex: number;

  let stepper = getContext<StepperControl>("stepper");
  stepper.changes.subscribe((_) => {
    const currentStep = stepper.step;
    steps = stepper.steps
      .filter(
        (_) =>
          !_.hidden || // show visible steps only
          _.number === currentStep + 1 || // show a hidden step only if it is the next step
          _.number === currentStep || // and keep it visible while it is active
          (currentStep > 1 && currentStep > _.number) // and keep it visible after it is done
      )
      .map((_, i) => ({ ..._, index: i }));

    currentIndex = steps.find((_) => _.number === currentStep).index;

    progress = offset(currentIndex);
  });

  function offset(stepIndex: number) {
    const step = steps.find((step) => step.index === stepIndex);
    return logOffset(stepOffset(step.index)) * 100;
  }

  function stepOffset(step: number) {
    if (step == 0) return 0;
    return step / (steps.length - 1);
  }

  function logOffset(percent: number) {
    return Math.max(0, Math.log10(percent * 10));
  }
</script>

<div class="line">
  <div class="line-done" style:width={progress + "%"} />
  {#each steps as step (step)}
    <div class="line-step" class:step-hidden={step.hidden} class:active={step.index <= currentIndex} style:left={offset(step.index) + "%"} title="{step.index + 1}. {step.name}">
      <span>{step.index + 1}. {step.name}</span>
    </div>
  {/each}
</div>

<style lang="scss">
  .line {
    --size: 20px;
    position: relative;
    width: 100%;
    height: var(--size);
    margin-left: calc(var(--size) / 2);
    margin-right: calc(var(--size) / 2);

    &:before,
    .line-done {
      content: "";
      position: absolute;
      top: 50%;
      left: 0;
      width: 100%;
      border-top: solid 4px #d9d9d9;
      transform: translate3d(0, -50%, 0);
    }

    .line-done {
      border-color: #ffbc00;
    }
  }

  .line-step {
    position: absolute;
    top: 50%;
    transform: translate3d(-50%, -50%, 0);
    width: var(--size);
    height: var(--size);
    background-color: #d9d9d9;
    border: solid 3px #fff;
    border-radius: 50%;

    // &.step-hidden {
    //   opacity: 0.6;
    // }

    span {
      display: none;
    }

    &.active {
      background-color: #ffbc00;
    }
  }
</style>
